import ru from 'vee-validate/dist/locale/ru';
import en from 'vee-validate/dist/locale/en';
import es from 'vee-validate/dist/locale/es';
import vi from 'vee-validate/dist/locale/vi';

import english from '@/i18n/lang/english.js';
import russian from '@/i18n/lang/russian.js';
import spanish from '@/i18n/lang/spanish.js';
import kazakh from '@/i18n/lang/kazakh.js';
import ukrainian from '@/i18n/lang/ukrainian.js';
import vietnamese from "@/i18n/lang/vietnamese.js";

const config = {
    es: {
        messages: {
            ...es.messages,
            confirmed: (field, ref) => `El valor del campo no coincide con el valor del campo ${ref[0]}`,
            required: field => 'El campo es obligatorio',
        },
        attributes: spanish.es.attributes
    },
    ru: {
        messages: {
            ...ru.messages,
            confirmed: (field, ref) => `Значение поля не совпадает со значением поля ${ref[0]}`,
            required: field => 'Поле обязательно для заполнения',

        },
        attributes: russian.ru.attributes,
    },
    kz: {
        messages: {
            ...ru.messages,
            confirmed: (field, ref) => `Значение поля не совпадает со значением поля ${ref[0]}`,
            required: field => 'Поле обязательно для заполнения',

        },
        attributes: kazakh.kz.attributes,
    },
    ua: {
        messages: {
            ...ru.messages,
            confirmed: (field, ref) => `Значение поля не совпадает со значением поля ${ref[0]}`,
            required: field => 'Поле обязательно для заполнения',

        },
        attributes: ukrainian.ua.attributes,
    },
    vn: {
        messages: {
            ...vi.messages,
            confirmed: (field, ref) => `Giá trị trường không khớp với giá trị trường ${ref[0]}`,
            required: field => 'Hình ảnh của chúng tôi',

        },
        attributes: vietnamese.vn.attributes,
    },
};

export default config;
